import React, { useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload, faImages, faQrcode } from '@fortawesome/free-solid-svg-icons';
import './InfoGraphicsHome.css';

function InfoGraphicsHome() {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userName = authState?.user?.name || "User";
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/sheearns");
  };

  return (
    <div className="min-h-screen flex flex-col bg-black text-blue-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 mb-4 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="text-xl lg:text-2xl font-bold text-yellow-200">
          📊 Think5Whys Inforgraphics Dashboard
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-left text-blue-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 mt-2 rounded-md bg-blue-600 hover:bg-blue-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
            >
              Login
            </button>
          )}
        </div>

        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-7 h-7 flex items-center justify-center text-xl text-blue-300 bg-blue-500 rounded"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* MOBILE MENU */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#2a0f2f] border-b border-blue-800 px-4 py-2 animate-fadeIn">
          {isLoggedIn ? (
            <div className="flex flex-row items-center justify-center gap-3">
              <span className="text-blue-300 text-xs lg:text-sm whitespace-nowrap">
                {userName}
              </span>
              <button
                onClick={handleLogout}
                className="rounded-md bg-blue-600 hover:bg-blue-700 w-7 h-7 flex items-center justify-center text-white"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center gap-6">
              <Link to="/login" className="text-blue-300 hover:text-yellow-300">
                Login
              </Link>
            </div>
          )}
        </div>
      )}

      <div className="min-h-[80vh] bg-black px-4 mt-2">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 mb-8">
          <CardLink to="/infographics-mylist" icon={faQrcode} text="My Infographics" />
          <CardLink to="/myprofile-myfiles" icon={faFileUpload} text="My File Uploader" />
          <CardLink to="/infographics-mygallery" icon={faImages} text="My Gallery" />
        </div>

      </div>
      <footer className="bg-black border-t border-blue-800 text-white py-4 mt-auto">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions.
          </div>

          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

/* Card Component */
const CardLink = ({ to, icon, text }) => (
  <div className="bg-blue-700 p-3 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm text-white hover:text-gray-200">
      <FontAwesomeIcon icon={icon} className="text-xl mr-3" />
      {text}
    </Link>
  </div>
);

export default InfoGraphicsHome;
